import { create } from '@wix/fedops-logger';

class FedOps {
  constructor(appName) {
    if (appName) {
      this.appName = appName;
      this.fedopsLogger = create(appName, {
        /* options */
      });
    }
  }
  _getInstance(fnc) {
    if (this.fedopsLogger) {
      fnc(this.fedopsLogger);
    }
  }
  appLoaded() {
    try {
      this._getInstance(fedopsLogger => {
        // console.log(`appLoaded`, this.appName);
        fedopsLogger.appLoaded();
      });
    } catch (error) {
      console.error('Fedops error - appLoaded', error);
    }
  }

  interactionStarted(name) {
    try {
      this._getInstance(fedopsLogger => {
        // console.log(`interactionStarted`, name, this.appName);
        fedopsLogger.interactionStarted(name);
      });
    } catch (error) {
      console.error('Fedops error - interactionStarted', error);
    }
  }

  interactionEnded(name) {
    try {
      this._getInstance(fedopsLogger => {
        // console.log(`interactionEnded`, name, this.appName);
        fedopsLogger.interactionEnded(name);
      });
    } catch (error) {
      console.error('Fedops error - interactionEnded', error);
    }
  }
}

let fedopsName;
if (typeof window === 'object' && window.__DEVOPS_APP_NAME__) {
  fedopsName = window.__DEVOPS_APP_NAME__;
}

export default new FedOps(fedopsName);
